import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import {
	fetchAllEmailCampaigns,
	fetchSingleEmailCampaign,
	fetchCampaignStatusEnum,
	fetchCampaignKPIs,
} from '../../api/emailCampaignsApi';

import { emailCampaignsKeys } from './keys';

export const emailCampaignsListOptions = () =>
	queryOptions({
		queryKey: emailCampaignsKeys.list(),
		queryFn: async () => {
			const { data, error } = await fetchAllEmailCampaigns();
			if (error) throw error;
			return data ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

export function useEmailCampaigns() {
	return useQuery(emailCampaignsListOptions());
}

export const singleEmailCampaignOptions = (campaignId) =>
	queryOptions({
		queryKey: emailCampaignsKeys.detail(campaignId),
		queryFn: async () => {
			const { data, error } = await fetchSingleEmailCampaign(campaignId);
			if (error) throw error;
			return data;
		},
		staleTime: STALE_TIMES.STANDARD,
	});

export function useSingleEmailCampaign(campaignId) {
	return useQuery({
		...singleEmailCampaignOptions(campaignId),
		enabled: Boolean(campaignId),
	});
}

export const campaignStatusEnumOptions = () =>
	queryOptions({
		queryKey: emailCampaignsKeys.statusEnum,
		queryFn: async () => {
			const { data, error } = await fetchCampaignStatusEnum();
			if (error) throw error;
			return data ?? [];
		},
		staleTime: STALE_TIMES.STATIC,
		retry: 2,
	});

export function useCampaignStatusEnum() {
	return useQuery(campaignStatusEnumOptions());
}

export const campaignKPIsOptions = () =>
	queryOptions({
		queryKey: emailCampaignsKeys.kpis(),
		queryFn: async () => {
			const { data } = await fetchCampaignKPIs();
			return (
				data ?? {
					sent: 0,
					delivered: 0,
					pending: 0,
					openRate: 0,
					clickRate: 0,
				}
			);
		},
		staleTime: STALE_TIMES.FREQUENT,
		retry: 2,
	});

export function useCampaignKPIs() {
	return useQuery(campaignKPIsOptions());
}
